import { ICoreContext } from '@msdyn365-commerce/core';
import React, { MutableRefObject } from 'react';
import { toast } from 'sonner';
import GetDocumentDownload, { GetDocumentDownloadInput } from '../actions/order-details/get-document-download.action';

export const getDocumentDownload = async (
    documentId: string,
    documentDownloadAlreadyDownloaded: MutableRefObject<Set<string>>,
    context: ICoreContext,
    resources: any
) => {
    if (documentDownloadAlreadyDownloaded.current.has(documentId)) {
        return null;
    }
    documentDownloadAlreadyDownloaded.current.add(documentId);

    try {
        const actionInput = new GetDocumentDownloadInput(documentId);
        const documentDownload = await GetDocumentDownload(actionInput, context.actionContext);
        const documentContent = `data:application/pdf;base64,${documentDownload.Content}`;

        if (!documentDownload.Content || documentDownload.Content.length === 0) {
            documentDownloadAlreadyDownloaded.current.delete(documentId);
            toast.error(
                <div className='toast' role='alert'>
                    <div className='toast-header'>
                        <h4>{resources.globalDownloadErrorHeading}</h4>
                        <button className='toast-close' onClick={() => toast.dismiss()}></button>
                    </div>
                    <div className='toast-body'>
                        <span>{resources.globalDownloadErrorNoContentDescription}</span>
                    </div>
                </div>
            );
            return null;
        }

        const tempLink = document.createElement('a');
        tempLink.href = documentContent;
        tempLink.download = documentDownload.FileName || 'download.pdf';
        tempLink.style.display = 'none';

        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
    } catch (error) {
        documentDownloadAlreadyDownloaded.current.delete(documentId);
        toast.error(
            <div className='toast' role='alert'>
                <div className='toast-header'>
                    <h4>{resources.globalErrorHeading}</h4>
                    <button className='toast-close' onClick={() => toast.dismiss()}></button>
                </div>
                <div className='toast-body'>
                    <span>{resources.globalErrorServiceNotAvailable}</span>
                </div>
            </div>
        );
        console.error('Error document download', error);
        return error;
    }

    return null;
};
